import { HttpClient } from '@angular/common/http'
import { Component, NgZone } from '@angular/core'
import { AuthService } from 'app/_services'
import { LoaderService } from 'app/_services/loader.service'
import { environment } from 'environments/environment'
declare var $: any

@Component({
  selector: 'assetIssueDetails',

  templateUrl: './assetIssueDetails.component.html',
})
export class AssetIssueDetailsReportComponent {
  showLoader: boolean
  public EmployeeName: any
  public EmployeeCode: any
  public EmployeeContactNumber: any
  public EmployeeLocation: any
  public EmployeeHodName: any
  public EmployeeDepartmentName: any
  public EmployeeDesignation: any
  public EmployeeApproval: any
  public EmployeeHodApproval: any
  assetFullname: { id: number; name: string }[]

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private _ngZone: NgZone,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
  }

  ngOnInit() {
    this.showLoader = false
    this.assetFullname = [
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
      { id: 1, name: 'Dell D323 ( Ser/IMI- 3215647895)' },
      { id: 2, name: 'Mouse D323 ( Ser/IMI- DL5647895)' },
      { id: 3, name: 'Battery D323 ( Ser/IMI- CL3215647895)' },
    ]
  }

  openAssetForm() {
    $('#addAssetItem').modal('show')
  }

  saveAssetForm() {
    var assetJsonData = {}

    this.http
      .post(environment.apiUrl + 'reports/saveAssetEmpData', assetJsonData)
      .subscribe(
        (data) => {
          console.log(data)
        },
        (err) => {
          console.log('255', err)
        },
      )
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/itAsset/assetIssueDetails.components.ts